<script>
import GridFileView from "./components/GridFileView/GridFileView.vue";
import FileViewOptions from "./components/FileViewOptions/FileViewOptions.vue";
import ListFileView from "./components/ListFileView/ListFileView.vue";
import SpinnerLoader from '../../../../../Pages/components/loaders/SpinnerLoader.vue';
import FormModal from "../../../../components/modals/FormModal.vue";
import FormPasswordInput from "../../../../components/forms/FormPasswordInput.vue";
import axios from "axios";
import { eventBus } from "../../../../assets/eventBus";
import { Inertia } from '@inertiajs/inertia';

export default {
    props: {
        allItems: {
            type: Array,
            default: [],
            required: true,
        },
        title: {
            type: String,
            default: "",
            required: true,
        },
        view: {
            type: "grid" | "list",
            default: "grid",
            required: false,
        },
        searchOption: {
            type: Boolean,
            default: false,
        },
        itemsPerPageOption: {
            type: Boolean,
            default: false
        },
        viewAllOption: {
            type: Boolean,
            default: false,
        },
        moreOptions: {
            type: Boolean,
            default: false,
        },
        gridListOption: {
            type: Boolean,
            default: false,
        },
        listViewColumns: {
            type: Array,
            default: [],
            required: true,
        },
        sortParam: {
            type: String,
            default: null
        },
        activeSortedColumn: {
            type: String,
            default: null
        },
        isLoading: Boolean,
        noDataTitle: {
            type: String,
            default: null,
            required: true,
        },
        dataType: {
            type: String,
            default: null
        },
        classes: {
            type: String,
            required: true
        },
        increment: {
            type: Number,
            required: true
        },
        isDataLoading: {
            type: Boolean,
            required: true
        },
        onMounted: {
            type: Function,
            required: true
        },
        perpage: {
            type: Number,
            default: 12,
            required: true
        },
        options: {
            type: Array,
            default: () => {
                return []
            }
        },
        hasCurrentFolderPassword: {
            type: Boolean,
            default: false
        },
        selectedFolderId: {
            type: [Number, String]
        },
        showFolderContentFunc: {
            type: Function,
            default: (value) => {}
        },
        routeType: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            isShowModal: false,
            modalTitle: null,
            submitButtonText: null,
            passwordVerificationType: null,
            inputPassword: '',
            inputNewPassword: '',
            item: null,
            passwordErrors: {},
            isButtonLoading: false,
            noClose: false,
            isShowCancelButton: true,
            isShowSubmitButton: true,
            isShowFolderContent: true
        }
    },
    methods: {
        showModal(title, type, item, noClose = false) {
            if(noClose) {
                this.noClose = true
                this.isShowCancelButton = false
            }
            this.item = item
            this.passwordVerificationType = type
            this.modalTitle = title
            this.defaultsubmitButtonText(type)
            this.isShowModal = true
        },
        defaultsubmitButtonText(type) {
            if(type === 'protect') {
                this.submitButtonText = 'Protect'
            }
            else if(type === 'unprotect') {
                this.submitButtonText = 'Unprotect'
            }
            else if(type === 'unlock') {
                this.submitButtonText = 'Unlock'
            }
            else if (type === 'forgotmatch') {
                this.submitButtonText = 'Verify'
            }
            else if (type === 'recover') {
                this.submitButtonText = 'Confirm'
            }
            else {
                this.submitButtonText = 'Change Password'
            }
        },
        hideModal() {
            this.inputPassword = ''
            this.inputNewPassword = ''
            this.passwordErrors = {}
            this.isShowModal = false
            this.noClose = false
            this.isShowCancelButton = true
        },
        handleProtectedSubmit(type, id, dataType, item) {
            let password = this.inputPassword
            let newPassword = this.inputNewPassword
            let formData = new FormData()
            let routeURL = route(this.userTypeAbbr + '-protected-files-folders')
            formData.append('id', id)
            formData.append('dataType', dataType)
            formData.append('password', password)
            if(type === 'changePassword' || type === 'recover') {
                formData.append('newPassword', newPassword)
            }
            formData.append('type', type)
            this.$refs.topProgress.start()
            this.submitButtonText = `<i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>Loading`
            this.isButtonLoading = true
            axios.post(
            routeURL,
            formData, {
            })
            .then(response => {
                if(response.data.status) {
                    if(type === 'protect') {
                        (dataType === 'files') ? this.$toastr.s('Selected file is protected.') : this.$toastr.s('Selected folder is protected.')
                        eventBus.reloadFolderFile('Protect', dataType)
                    }
                    else if(type === 'unprotect') {
                        (dataType === 'files') ? this.$toastr.s('Selected file is unprotected.') : this.$toastr.s('Selected folder is unprotected.')
                        eventBus.reloadFolderFile('Unprotect', dataType);
                    }
                    else if (type === 'forgotmatch') {
                        setTimeout(() => {
                            this.showModal(`Recover password for ''${item.name}''`, 'recover', item);
                        }, 1000);
                    }
                    else if (type === 'recover') {
                        (dataType === 'files') ? this.$toastr.s('Selected file password is recovered.') : this.$toastr.s('Selected folder password is recovered.')
                        eventBus.reloadFolderFile(dataType);
                    }
                    else if(type === 'changePassword') {
                        (dataType === 'files') ? this.$toastr.s('Selected file password is changed.') : this.$toastr.s('Selected folder password is changed.')
                        eventBus.reloadFolderFile(dataType);
                    }
                    else {
                        this.$toastr.s('Password verified.');
                        localStorage.getID = JSON.stringify(item.id);
                        this.isShowFolderContent = true
                        this.showFolderContentFunc(this.isShowFolderContent)
                        if(item.viewUrl) {
                            (dataType == 'files') ? window.open(item.viewUrl, '_blank') : Inertia.visit(item.viewUrl)
                        }    
                    }
                    this.hideModal()
                }
                else {
                    this.passwordErrors = {};
                    this.passwordErrors = {
                        ...this.passwordErrors,
                        password: response.data.message,
                        newPassword: response.data.newMessage,
                        passwordHint: type === 'unlock' ? response.data.passHint : null
                    }
                }
                this.$refs.topProgress.done()
                this.defaultsubmitButtonText(type)
                this.isButtonLoading = false
            })
            .catch(err => {
                this.passwordErrors = {}
                if(err.response.status == 422) {
                    this.passwordErrors = {
                        ...this.passwordErrors, 
                        password: err.response.data.errors.password ? err.response.data.errors.password[0] : null,
                        newPassword: err.response.data.errors.newPassword ? err.response.data.errors.newPassword[0] : null,
                        id: err.response.data.errors.id ? err.response.data.errors.id[0] : null,
                        dataType: err.response.data.errors.dataType ? err.response.data.errors.dataType[0] : null,
                        type: err.response.data.errors.type ? err.response.data.errors.type[0] : null
                    }
                    if(this.passwordErrors.id || this.passwordErrors.dataType || this.passwordErrors.type) {
                        this.$toastr.e('Something went wrong, Please try again')
                    }
                }
                else if(err.response.status == 401) {
                    this.$toastr.e(err.response.data.message)
                }
                this.$refs.topProgress.done()
                this.defaultsubmitButtonText(type)
                this.isButtonLoading = false
            });

        },
        passwordSubmit() {
            let id = this.item.dataType === 'files' ? this.item.photoId : this.item.id;
            this.handleProtectedSubmit(this.passwordVerificationType, id, this.item.dataType, this.item)
        },
        isShowUnlockModalOnUrlClick() {
            let getID = JSON.parse(localStorage.getID || null)
            if(!getID && this.hasCurrentFolderPassword || (getID && this.hasCurrentFolderPassword && getID != this.selectedFolderId)) {
                this.item = {
                    ...this.item,
                    id: this.selectedFolderId,
                    dataType: 'folders'
                }
                this.isShowFolderContent = false
                this.modalTitle = 'Confirm password to unlock'
                this.showModal(this.modalTitle, 'unlock', this.item, true)
            }
        }
    },
    computed: {
        userTypeAbbr() {
            return this.$page.props.auth.user.user_type_abbr;
        }
    },
    components: { GridFileView, FileViewOptions, ListFileView, SpinnerLoader, FormModal, FormPasswordInput },
    mounted() {
        let self = this
        eventBus.$off('openUnlockModal')
        eventBus.$on('openUnlockModal', (item) => {
            self.showModal(`Confirm password to unlock ''${item.name}''`, 'unlock', item);
        });
        self.isShowFolderContent = true
        self.isShowUnlockModalOnUrlClick()
        self.showFolderContentFunc(self.isShowFolderContent)
    }
};
</script>

<template>
    <div>
        <vue-topprogress ref="topProgress" :height="2"></vue-topprogress>
        <div>
            <div class="row align-items-center mb-3 mt-0">
                <div class="col-lg-4 col-sm-5">
                    <div>
                        <p class="text-muted mb-0" v-html="title"></p>
                    </div>
                </div>
                <FileViewOptions
                    v-if="isShowFolderContent"
                    :search="searchOption"
                    :moreOptions="moreOptions"
                    :viewAll="viewAllOption"
                    :gridListOption="gridListOption"
                    :view="view"
                    :dataType="dataType"
                    :onMounted="onMounted"
                    :itemsPerPageOption="itemsPerPageOption"
                    :perpage="perpage"
                    :options="options"
                    :selectedFolderId="selectedFolderId"
                    :routeType="routeType"
                />

            </div>
        </div>
        <hr class="mb-4" />
        <div v-if="view === 'grid'">            
            <div v-if="isLoading" class="row d-flex align-items-center justify-content-center">
                <SpinnerLoader classes="spinner-border text-success" role="status" title="Loading..." />
            </div>
            <div v-else>
                <GridFileView 
                    v-if="isShowFolderContent"
                    :allItems="allItems"
                    :noDataTitle="noDataTitle"
                    :classes="classes"
                    :increment="increment"
                    :isDataLoading="isDataLoading"
                    :onMounted="onMounted"
                    :perpage="perpage"
                    :showModal="showModal"
                    :routeType="routeType"
                    :dataType="dataType"
                />
                <div v-else class="text-center"><i class="mdi mdi-lock text-secondary"></i> Folder is currently protected.</div>
            </div>
        </div>
        <div v-else>
            <div v-if="isLoading" class="row d-flex align-items-center justify-content-center">
                <SpinnerLoader classes="spinner-border text-success" role="status" title="Loading..." />
            </div>
            <div v-else>
                <ListFileView 
                    v-if="isShowFolderContent"
                    :allItems="allItems"
                    :columns="listViewColumns"
                    :sortParam="sortParam"
                    :activeSortedColumn="activeSortedColumn"
                    :noDataTitle="noDataTitle"
                    :classes="classes"
                    :increment="increment"
                    :isDataLoading="isDataLoading"
                    :onMounted="onMounted"
                    :perpage="perpage"
                    :showModal="showModal"
                    :routeType="routeType"
                    :dataType="dataType"
                />
                <div v-else class="text-center"><i class="mdi mdi-lock text-secondary"></i> Folder is currently protected.</div>
            </div>
        </div>
        <FormModal
            :isShow="isShowModal"
            :title="modalTitle"
            :isButtonLoading="isButtonLoading"
            :isShowSubmitButton="isShowSubmitButton"
            :clickSubmitButton="passwordSubmit"
            :submitButtonText="submitButtonText"
            :isShowCancelButton="isShowCancelButton"
            @hideModal="hideModal"
            :noClose="noClose"
        >
                <div 
                    v-if="passwordErrors.passwordHint" 
                    class="text-primary mb-2"
                >
                    Hint: {{ passwordErrors.passwordHint }}
                </div>
                <FormPasswordInput
                    :title="passwordVerificationType === 'changePassword' ? 'Old Password' : (passwordVerificationType === 'recover' ? 'New Password' : (passwordVerificationType === 'forgotmatch' ? 'Profile Password' : 'Password'))"
                    refID="password"
                    name="password"
                    type="password"
                    v-model="inputPassword"
                    :error="passwordErrors.password"
                    :onEnter="passwordSubmit"
                />
                <FormPasswordInput
                    v-if="(passwordVerificationType === 'changePassword') || (passwordVerificationType === 'recover')"
                    refID="newPassword"
                    :title="passwordVerificationType === 'changePassword' ? 'New Password' : 'Confirm New Password'"
                    name="newPassword"
                    type="password"
                    v-model="inputNewPassword"
                    :error="passwordErrors.newPassword"
                    :onEnter="passwordSubmit"
                />
        </FormModal>
    </div>
</template>